document.addEventListener("DOMContentLoaded", () => {
  try {
    console.log("Script loaded...");

    // Get modal elements
    const modal = document.getElementById("popup_modal");
    const overlay = document.getElementById("popup_overlay");
    const modalMessage = document.getElementById("modal_message");
    const confirmButton = document.getElementById("modal_confirm");
    const cancelButton = document.getElementById("modal_cancel");
    const closeButton = document.querySelector(".modal_close_button");

    // Get the clear and edit buttons
    const clearButton = document.getElementById("popup_clear_button");
    const editButton = document.getElementById("popup_edit_button");

    if (!modal || !overlay || !modalMessage || !confirmButton || !cancelButton || !closeButton) {
      console.error("Modal elements are missing from the HTML.");
      return;
    }

    if (!clearButton || !editButton) {
      console.error("Clear or Edit button not found.");
      return;
    }

    console.log("All elements found. Attaching event listeners...");

    // Attach event listener to Clear button
    clearButton.addEventListener("click", (event) => {
      event.preventDefault();
      console.log("Clear button clicked...");
      showModalWithConfirmation("Are you sure you want to clear the selected items in your box?", () => {
        fetch("/cart/clear.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Cart cleared:", data);
            localStorage.setItem("giftBoxItems", JSON.stringify([]));
            location.reload();
          })
          .catch((error) => console.error("Error clearing cart:", error));
      });
    });

    // Attach event listener to Edit button
    editButton.addEventListener("click", (event) => {
      event.preventDefault();
      console.log("Edit button clicked...");
      const closeBtn = document.querySelector(".drawer__close-btn");
      if (closeBtn) {
        closeBtn.click();
      } else {
        console.warn("Drawer close button not found.");
      }
    });

    // Assign modal close functionality
    overlay.addEventListener("click", hideModal);
    closeButton.addEventListener("click", hideModal);
    cancelButton.addEventListener("click", hideModal);

    // Listen for Escape key to close modal
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") hideModal();
    });

    function showModalWithConfirmation(message, onConfirm) {
      console.log("Showing modal...");
      modalMessage.textContent = message;
      modal.classList.add("show");
      overlay.classList.add("show");

      // Attach confirmation action
      confirmButton.onclick = () => {
        hideModal();
        onConfirm();
      };
    }

    function hideModal() {
      console.log("Hiding modal...");
      modal.classList.remove("show");
      overlay.classList.remove("show");
    }
  } catch (error) {
    console.error("Error while initializing script:", error);
  }
});
